const store = require('../../store/').default;
import Vue from 'vue'
import ModalInfo from '../modal/Info';
import ModalPrice from '../modal/Price';
import ModalConfirm from '../modal/Confirm';
Vue.component('modal-info', ModalInfo);
Vue.component('modal-price', ModalPrice);
Vue.component('modal-confirm', ModalConfirm);

export default {
  info (message, onOk) {
    store.dispatch('openModal', {
      component: 'modal-info',
      params: {
        message: message,
        onOk: onOk
      },
    });
  },
  sizeModal(params) {
    store.dispatch('openModal', {
        component: 'modal-info',
        params: params,
    });
  },
  priceModal(params) {
    store.dispatch('openModal', {
      component: 'modal-price',
      params: params,
    });
  },
  confirm (params) {
    store.dispatch('openModal', {
      component: 'modal-confirm',
      params: params,
    });
  },
  close () {
    store.dispatch('closeModal');
  },
}
